import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SunIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.75881 14.6049C8.75881 15.0246 8.41855 15.3649 7.99882 15.3649C7.57908 15.3649 7.23881 15.0246 7.23881 14.6049V13.1249C7.23881 12.7051 7.57908 12.3649 7.99882 12.3649C8.41855 12.3649 8.75881 12.7051 8.75881 13.1249V14.6049Z"
		/>
		<path
			fill="currentColor"
			d="M5.17157 11.192C4.87477 10.8952 4.39357 10.8952 4.09677 11.192L3.05025 12.2386C2.75345 12.5354 2.75345 13.0166 3.05025 13.3134C3.34705 13.6102 3.82825 13.6102 4.12505 13.3134L5.17157 12.2668C5.46837 11.97 5.46837 11.4888 5.17157 11.192Z"
		/>
		<path
			fill="currentColor"
			d="M10.8286 11.1919C10.5318 11.4887 10.5318 11.9699 10.8286 12.2667L11.8751 13.3132C12.1719 13.61 12.6531 13.61 12.9499 13.3132C13.2467 13.0164 13.2467 12.5352 12.9499 12.2384L11.9034 11.1919C11.6066 10.8951 11.1254 10.8951 10.8286 11.1919Z"
		/>
		<path
			fill="currentColor"
			d="M10.1144 6.24917C11.286 7.42074 11.286 9.32024 10.1144 10.4918C8.94285 11.6634 7.04335 11.6634 5.87178 10.4918C4.70021 9.32024 4.70021 7.42074 5.87178 6.24917C7.04335 5.0776 8.94285 5.0776 10.1144 6.24917Z"
		/>
		<path
			fill="currentColor"
			d="M3.05042 4.48846C2.75362 4.19166 2.75362 3.71046 3.05042 3.41366C3.34722 3.11686 3.82843 3.11686 4.12523 3.41366L5.17174 4.46018C5.46854 4.75698 5.46854 5.23818 5.17174 5.53498C4.87495 5.83178 4.39374 5.83178 4.09694 5.53498L3.05042 4.48846Z"
		/>
		<path
			fill="currentColor"
			d="M11.8749 3.41382C12.1717 3.11702 12.6529 3.11702 12.9497 3.41382C13.2465 3.71062 13.2465 4.19182 12.9497 4.48862L11.9032 5.53514C11.6064 5.83194 11.1252 5.83194 10.8284 5.53514C10.5316 5.23834 10.5316 4.75714 10.8284 4.46034L11.8749 3.41382Z"
		/>
		<path
			fill="currentColor"
			d="M14.2394 7.60416C14.6592 7.60416 14.9994 7.94442 14.9994 8.36416C14.9994 8.7839 14.6592 9.12416 14.2394 9.12416H12.7594C12.3397 9.12416 11.9994 8.7839 11.9994 8.36416C11.9994 7.94442 12.3397 7.60416 12.7594 7.60416H14.2394Z"
		/>
		<path
			fill="currentColor"
			d="M4 8.36356C4 7.94382 3.65974 7.60356 3.24 7.60356H1.76C1.34026 7.60356 1 7.94382 1 8.36355C1 8.78329 1.34026 9.12356 1.76 9.12356H3.24C3.65974 9.12356 4 8.78329 4 8.36356Z"
		/>
		<path
			fill="currentColor"
			d="M7.99821 4.36539C8.41795 4.36539 8.75821 4.02513 8.75821 3.60539V2.12539C8.75821 1.70566 8.41795 1.36539 7.99821 1.36539C7.57847 1.36539 7.23821 1.70566 7.23821 2.12539V3.60539C7.23821 4.02513 7.57847 4.36539 7.99821 4.36539Z"
		/>
	</svg>
))
